(function (angular) {
    'use strict';

    angular.module('shared')
        .factory('resetPasswordService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;
                // urlBase = 'http://localhost:8001';
                var fac = {
                    startPasswordReset: startPasswordReset,
                    completePasswordReset: completePasswordReset,
                    provideVerifyCode: provideVerifyCode
                };
                return fac;


                function startPasswordReset(method, userName) {
                    return $http.post(urlBase + "/membership/startpasswordreset?method=" + method, { userName: userName })
                        .then(startPasswordResetComplete)
                        .catch(startPasswordResetFailed);

                    function startPasswordResetComplete(response) {
                        return response.data;
                    }

                    function startPasswordResetFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                function provideVerifyCode(accountId, userId, verifyId, code) {
                    return $http.post(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/completeVerify", { verifyId: verifyId, code: code })
                        .then(createNewAccountComplete)
                        .catch(createNewAccountFailed);

                    function createNewAccountComplete(response) {
                        return response.data;
                    }

                    function createNewAccountFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                function completePasswordReset(accountId, userId, passwordResetId, newPassword) {
                    return $http.post(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/completepasswordreset", { passwordResetId: passwordResetId, newPassword: newPassword })
                        .then(completePasswordResetComplete)
                        .catch(completePasswordResetFailed);

                    function completePasswordResetComplete(response) {
                        return response.data;
                    }

                    function completePasswordResetFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }
            }
        ]);
})(window.angular);